import { createClient } from '@supabase/supabase-js';

let _supabase = null;

function getConfig() {
  const rc = typeof window !== 'undefined' && window.__RUNTIME_CONFIG__;
  const url = import.meta.env.VITE_SUPABASE_URL || (rc && rc.VITE_SUPABASE_URL) || '';
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY || (rc && rc.VITE_SUPABASE_ANON_KEY) || '';
  return { url, key };
}

/**
 * Get the Supabase client instance. Initializes lazily on first call.
 * This avoids the race condition where the module loads before
 * window.__RUNTIME_CONFIG__ is injected by the Express server.
 */
export function getSupabase() {
  if (_supabase) return _supabase;

  const { url, key } = getConfig();
  if (url && key) {
    _supabase = createClient(url, key, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });
  }

  return _supabase;
}

/**
 * Get the Supabase client or throw if unavailable.
 * Use in auth functions that cannot proceed without a client.
 */
export function getSupabaseOrThrow() {
  const supabase = getSupabase();
  if (!supabase) {
    throw new Error('Unable to connect to authentication service. Please refresh the page.');
  }
  return supabase;
}
